export const phoneValidation = (v: string) => !v || /^[+\d]\d*$/.test(v);
